import Service, { inject as service } from '@ember/service';
import DS from 'ember-data';
import TagModel from 'cio/models/tag';
import ApiErrorsService from 'cio/services/api-errors';

export default class TagsService extends Service {
  @service store!: DS.Store;
  @service apiErrors!: ApiErrorsService;

  async addTag(name: string) {
    let existingTag = this.store.peekAll('tag').findBy('name', name);
    if (existingTag) {
      return existingTag;
    }

    try {
      return this.createTag({ name });
    } catch (err) {
      this.apiErrors.report(err);

      throw err;
    }
  }

  private createTag({ name }: { name: string }): Promise<TagModel> {
    let tag = this.store.createRecord('tag', { name });
    return tag.save();
  }

  async loadTags() {
    return this.store.findAll('tag');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    tags: TagsService;
  }
}
